import React from 'react';
import Loadable from 'react-loadable';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';

let ListPageComponent = false;

if (process.env.RUNTIME_ENV !== 'browser') {
  // eslint-disable-next-line global-require
  ListPageComponent = require('./world_changing_ideas_list_page').default;
}
/**
 * List Lander Page
 */
export default function wciListPage(store) {
  const routeConfig = {
    path: '/world-changing-ideas/:page(list)',
    component() {
      if (ListPageComponent) {
        return <ListPageComponent />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: ListPageComponent ? ListPageComponent.loadData(store) : false,
    preloadChunk() {
      return import('./world_changing_ideas_list_page').then(resp => {
        ListPageComponent = resp.default;
        routeConfig.loadData = ListPageComponent.loadData(store);

        return ListPageComponent;
      });
    },
    chunk: 'wciListPage'
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}
